export const createClickAwayListenerProps = (autoDismissTimeout: number | undefined, onDismiss: () => void) => ({
  onClickAway:
    autoDismissTimeout && autoDismissTimeout > 0
      ? () => onDismiss()
      : () => {
          // Prevent dismiss on click outside if autoDismissTimeout is 0
        },
})
